module.exports = __webpack_public_path__ + "img/flecha_arriba_inactiva.832f051f.svg";